import { InstanceUrl } from "@tento-core/instance-url";

// Public instance hosts use their matching static service. The standalone
// fleet app declares a static origin in its document before Storybook boots.
const configured = document.querySelector<HTMLMetaElement>("meta[name=ui-catalog-static-origin]")?.content;
const publicInstance = window.location.hostname === "lona.so" || window.location.hostname.endsWith(".lona.so");
InstanceUrl.setStaticBase(publicInstance ? InstanceUrl.url("", "static") : configured || "https://dev--static.lona.so");
